// materialimport { useTheme } from '@material-ui/core/styles'
import { Box, Grid, Button, Card, Stack, Typography, TextField, MenuItem, Checkbox, makeStyles, CircularProgress, AvatarGroup, Tooltip, Avatar, InputAdornment, TableContainer, Table, Paper, TableHead, TableRow, TableCell, TableBody, IconButton, useMediaQuery, Slide, FormControlLabel, RadioGroup, FormControl, Radio, Autocomplete, Alert } from '@material-ui/core'
import { useTheme,alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { isAdminUser } from '../../../../utils/adminUserTypes';
import AddTask from '../../AddTask'
import { forwardRef, useEffect, useRef, useState } from 'react'
import { UserMoreMenu } from 'src/components/_dashboard/user/list';
import ConfirmationPopup from 'src/components/confirmationPopup';
import WarningMaterialPopup from 'src/components/WarningMaterialPopup';
import axios from 'axios';
import { BASE_URL, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import { KeyboardBackspaceOutlined, Login, Logout, QrCodeScanner, Replay, Search, Visibility } from '@material-ui/icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,Slider as Sliderw } from '@mui/material';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import moment from 'moment';
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu';
import { empty } from 'src/Helpers/Common';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import QrReader from 'react-qr-reader';
import { Html5QrcodeScanner } from 'html5-qrcode';

const option = [
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#0275d8',
  '#008000',
  '#f0ad4e',
  '#5cb85c',
  '#c9302c',
  '#5cb85c',
  '#5cb85c',
  '#5bc0de',
]

const useStyles = makeStyles((theme) => ({
  card: {
      borderRadius: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative', 
  },
  delete:{
    m:2,
    display:'flex',
    justifyContent:'flex-end' 
  },
  media: {
      height: 0,
      paddingTop: '100%', 
      width: '100%',
      objectFit: 'fill', 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      left: theme.spacing(1),
      zIndex:999,
  },
  gridContainer: {
      height: '350px', 
      overflowY: 'auto', 
      '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.1)',
          borderRadius: '4px',
        },
  },
}));

function ProjectStatusPopup({ open, onClose, staffTimeLogData, handleClockInOut, autoClockoutTime }) {
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [timerId]);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleClockInOut();
      }, autoClockoutTime * 60 * 1000);

      setTimerId(timer);
    } else {
      if (timerId) {
        clearTimeout(timerId);
      }
    }
  }, [open]);
 
  return (
      <Dialog  onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(false);
        }
      }}>
          <DialogTitle>Are you still working on this project?</DialogTitle>
          <DialogContent>
              <DialogContentText sx={{mt:3}}>
                  Do you want to continue working on "{staffTimeLogData?.task_name}" in "{staffTimeLogData?.project_name}"?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button variant='contained' onClick={() => { clearTimeout(timerId); onClose(true); }}>
                  Yes
              </Button>
              <Button variant='outlined' onClick={() => { clearTimeout(timerId); onClose(false); }}>
                  No
              </Button>
          </DialogActions>
      </Dialog>
  );
}
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function EstimateSubTask({ requestDetails, details, taskData, data,setFetchData, projectMembers, taskId, projectId, setRefresh, refresh,currentTab,onDataChange, canManage = true, canUpdateStatus = true }) {
  console.log('taskDataaaa', taskData)
  console.log('details++', details)
  console.log('projectIdprojectId', projectId)
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { enqueueSnackbar } = useSnackbar();
  const [singleData, setSingleData] = useState(null)
  const [add, setAdd] = useState(false)
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [isDelete,setIsDelete] = useState(false)
  const [isEdit,setIsEdit] = useState(false)
  const [deleteStates, setDeleteStates] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [openService, setOpenService] = useState(false)
  const [confirmAdditionalJObCost, setConfirmAdditionalJObCost] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [materialData, setMaterialData] = useState(null)
  const [warningMaterialPopup, setWarningMaterialPopup] = useState(false)
  const [warningMaterialData, setWarningMaterialData] = useState(null)
  const [staffTimeLog, setStaffTimeLog] = useState(null)
  const [openPopup, setOpenPopup] = useState(false);
  const [searchMaterial, setSearchMaterial] = useState('');
  const [qty, setQty] = useState(1);
  const [viewMaterialData, setViewMaterialData] = useState([]);
  const [viewMaterial, setViewMaterial] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [subtaskStopwatches, setSubtaskStopwatches] = useState({}); // New state for per-subtask stopwatch
  const [editingStopwatchId, setEditingStopwatchId] = useState(null);
  const [editedTime, setEditedTime] = useState("");
  const classes = useStyles();
  const [completeStatus, setCompleteStatus] = useState(1)
  const [checkedItems, setCheckedItems] = useState([]);
  const [popUpTime, setPopUpTime] = useState(0);
  const [autoClockoutTime, setAutoClockoutTime] = useState(0);
  const [openPopupComplete, setOpenPopupComplete] = useState(false)
  const user = JSON.parse(window.localStorage.getItem('user'))
  let userType = user.user_type
  const explodedPermissions = user?.exploded_permissions
  const hasJobPermission = !!canUpdateStatus
  const canManageEstimateTaskSubtasks = !!canManage
  const[skillsandServices,setSkillsService]=useState([])
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const [finalTaskId, setFinalTaskId] = useState(null);
  const [finalTaskStatus, setFinalTaskStatus] = useState(null);
  const scannerRef = useRef(null);
  const [projectData,setProjectData] = useState(null) 
  console.log('projectData....', projectData)
  const [loading2,setLoading2] = useState(false)
  const [loadingInstall,setLoadingInstall] = useState(false)
  const [selectedService, setSelectedService] = useState(null);
  const [clockInServices,setclockInServices] = useState([])
  const [subTaskMembers,setSubTaskMembers] = useState([])
  console.log('subTaskMemberssssss', subTaskMembers)
  const [clockInInputs, setClockInInputs] = useState([]);
  console.log('clockInInputs', clockInInputs)
  const [subTaskId, setSubTaskId] = useState(null);
  const [fromStatus, setFromStatus] = useState(false);
  const [refreshProjectData, setRefreshProjectData] = useState(false);


  // const filteredClockInServices = [
  //   ...clockInServices?.filter((item) => item.labour_cost_service_id !== 10),
  //   clockInServices?.find((item) => item.labour_cost_service_id === 10)
  // ].filter(Boolean);

const filteredClockInServices = clockInServices?.filter(item => {
  if (taskData?.service_id == null) {
    return !!item.recipe_id;
  }
  return true;
}) || [];



  console.log('taskDataaaaa filteredClockInServices', filteredClockInServices)
    console.log('taskDataaaaa', taskData)

  const isClockInDisabled = subTaskMembers.every((member) => {
  const entry = clockInInputs.find((e) => e.staff_id === member.staff_id);
  const hasHour = entry?.hour > 0;
  // const hasService = entry?.service_id && entry?.service_id !== '';
  return !(hasHour);
});

useEffect(() => {
  if (taskData?.service_id != null) {
    setSelectedService(taskData?.customer_order_product_id);
    console.log('taskData.service_id',taskData.customer_order_product_id)
    console.log('taskData.service_id data',taskData)
  }
}, [taskData]);

  useEffect(()=>{
    fetchProjectData()
  },[refreshProjectData])

  const fetchProjectData = async () => {
    try {
      const  res = await axios.post(`${REST_API_END_POINT}jobs/get-project-details-by-id`, { projectId: projectId });
      setProjectData(res?.data?.result[0]);
    } catch (error) {
      console.log("error",error)
      setProjectData(null)
    }
  }
  const userId = user?.user_id
  const[view,setView]=useState(false)
 console.log("##############details",details);
  const fetchClockSettings = async() => {
    try {
        const res = await axios.post(`${REST_API_END_POINT}settings/fetch-all-clock-settings`,{projectId, taskId})
        if(res.data.status === 1){
          setclockInServices(res?.data?.allServices)
            const settingsData = res.data.clocksettings
            settingsData?.map((item)=>{
              if(item?.id == 1){
                setPopUpTime(parseInt(item?.time))
              }else if(item?.id == 2){
                setAutoClockoutTime(parseInt(item?.time))
              }
            })
        }else{
          
            setPopUpTime(0)
            setAutoClockoutTime(0)
        }
    } catch (error) {
        console.log("Clock settings error : ",error)
        setPopUpTime(0)
        setAutoClockoutTime(0)
    }
  }
 
  useEffect(()=>{
    fetchClockSettings()
  },[])

  // Stopwatch Functions
  const fetchStopwatchData = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/fetch`, {
        userId: user.user_id,
        subtaskId: subtaskId
      });

      setSubtaskStopwatches(prev => {
        const newStopwatches = { ...prev };
      
        if (res.data.status === 1 && res.data.result.length > 0) {
          const sortedEntries = res.data.result.sort((a, b) => {
            const timeA = a.end_time || a.start_time;
            const timeB = b.end_time || b.start_time;
            return timeB - timeA; // Sort in descending order
          });

          const stoppedEntries = sortedEntries.filter(e => Number(e.status) === 0);
          const runningEntry = sortedEntries.find(e => Number(e.status) === 1);
      
          // ✅ Sum all stopped durations
          const stoppedTime = stoppedEntries.reduce((sum, e) => {
            if (e.start_time && e.end_time) {
              return sum + (e.end_time - e.start_time);
            }
            return sum;
          }, 0);
      
          let totalElapsed = stoppedTime;
          let isRunning = false;
          let stopwatchData = null;
      
          if (runningEntry) {
            // Clamp to 0: client clock can lag server start_time by ~1s and go negative
            const runningSeconds = moment().unix() - Number(runningEntry.start_time);
            totalElapsed += Math.max(0, runningSeconds);
            isRunning = true;
            stopwatchData = runningEntry;
          } else {
            stopwatchData = stoppedEntries[0] || null;
          }
      
          newStopwatches[subtaskId] = {
            stopwatchData,
            isRunning,
            elapsedTime: Math.max(0, totalElapsed)
          };
        } else {
          newStopwatches[subtaskId] = {
            stopwatchData: null,
            isRunning: false,
            elapsedTime: 0
          };
        }
      
        return newStopwatches;
      });

    } catch (error) {
      console.error(`Error fetching stopwatch data for subtask ${subtaskId}:`, error);
      setSubtaskStopwatches(prev => ({
        ...prev,
        [subtaskId]: { stopwatchData: null, isRunning: false, elapsedTime: 0 }
      }));
    }
  };

  const startStopwatch = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/start`, {
        userId: user.user_id,
        subtaskId: subtaskId,
        jobId: projectId
      });
      if (res.data.status === 1) {
        const now = moment().unix();
        const startedId =
          typeof res.data.result === 'object' && res.data.result !== null
            ? res.data.result.id ?? res.data.result
            : res.data.result;
        setSubtaskStopwatches((prev) => ({
          ...prev,
          [subtaskId]: {
            stopwatchData: {
              ...(prev[subtaskId]?.stopwatchData || {}),
              id: startedId,
              start_time: now,
              end_time: null,
              status: 1,
              subtask_id: subtaskId,
            },
            isRunning: true,
            elapsedTime: Math.max(0, prev[subtaskId]?.elapsedTime || 0),
          },
        }));
        enqueueSnackbar("Stopwatch started", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Re-fetch to update state
      } else {
        enqueueSnackbar("Failed to start stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error starting stopwatch:", error);
      enqueueSnackbar("Error starting stopwatch", { variant: 'error' });
    }
  };

  const stopStopwatch = async (stopwatchId, subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/stop`, {
        stopwatchId: stopwatchId,
        userId: user.user_id
      });
      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch stopped", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Re-fetch to update state
      } else {
        enqueueSnackbar("Failed to stop stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error stopping stopwatch:", error);
      enqueueSnackbar("Error stopping stopwatch", { variant: 'error' });
    }
  };

  const clearStopwatch = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/clear`, {
        subtaskId: subtaskId,
        userId: user.user_id
      });
  
      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch cleared", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Refresh UI
      } else {
        enqueueSnackbar("Failed to clear stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error clearing stopwatch:", error);
      enqueueSnackbar("Error clearing stopwatch", { variant: 'error' });
    }
  };

  const handleClockinTime = (members,taskId,fromStatus=false)=>{
    try {
      if (!hasJobPermission) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
        return
      }
      setSubTaskMembers(members)
      setOpenService(true)
      setSubTaskId(taskId)
      setFromStatus(fromStatus)
    } catch (error) {
      console.log('error',error )
    }
  }

  const handleConfirmAdditionalJobCost = async () => {
  try{
    let realQty = materialData?.balanceQty || (qty || 1)
    let values = [
      {
        productId: materialData.product_id || materialData.id,
        projectId: projectId,
        actual_quantity: materialData.actual_quantity || 0,
        actual_unit_cost: materialData.actual_unit_cost || 0,
        actual_total: materialData.actual_total || 0,

        // actual_quantity: project.unit_qty || 0,
        // actual_unit_cost: project.unit_cost || 0,
        // actual_total: project.actual_total_cost || 0,


        quantity: materialData?.balanceQty || (qty || 1),
        total: (materialData.unit_price * realQty) || (materialData.unit_cost * realQty),
        unitPrice: materialData.unit_price || materialData.unit_cost
      }
    ];  
    console.log('valuesssssssssssssssssssssss',values)
    axios.post(`${REST_API_END_POINT}project/add-job-cost`, 
      { userId: user.user_id, values, projectId, recipe: 0, selectedServices:[], scanQr : true, taskId,qty }, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else if (response?.data?.message) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
      }
      setConfirmAdditionalJObCost(false);
      setConfirmMessage('');
      setSearchMaterial('');
      setRefresh(!refresh);
      // onDataChange()
    }).catch((error) => {
      console.error(error);
      enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
    })
    setQty(1)
    }catch(error){
      console.log(error)
    }
  }

  const proceedWithMaterialAdditionFromData = async (materialDataToUse) => {
    try {
      let realQty = materialDataToUse?.balanceQty || (qty || 1)
      let values = [
        {
          productId: materialDataToUse.product_id || materialDataToUse.id,
          projectId: projectId,
          actual_quantity: materialDataToUse.actual_quantity || 0,
          actual_unit_cost: materialDataToUse.actual_unit_cost || 0,
          actual_total: materialDataToUse.actual_total || 0,
          quantity: materialDataToUse?.balanceQty || (qty || 1),
          total: (materialDataToUse.unit_price * realQty) || (materialDataToUse.unit_cost * realQty),
          unitPrice: materialDataToUse.unit_price || materialDataToUse.unit_cost
        }
      ];  
      
      const response = await axios.post(`${REST_API_END_POINT}project/add-job-cost`, {
        userId: user.user_id,
        values,
        projectId,
        recipe: 0,
        selectedServices: [],
        scanQr: true,
        taskId,
      });
      
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setRefresh(!refresh);
        // onDataChange()
      } else if (response.data.message) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
      }
    } catch (error) {
      console.log('Error in proceedWithMaterialAdditionFromData', error);
    }
  }

  const handleWarningConfirm = async () => {
    try {
      await proceedWithMaterialAdditionFromData(warningMaterialData)
      setWarningMaterialPopup(false)
      setWarningMaterialData(null)
      setSearchMaterial('')
    } catch (error) {
      console.log(error)
    }
  }

  const handleWarningClose = () => {
    setWarningMaterialPopup(false)
    setWarningMaterialData(null)
    setSearchMaterial('')
  }

  console.log('datadatadata====',data)
  const handleDeleteClick = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: true,
    }));
  };

  const handleCancelDelete = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: false,
    }));
  };
  const valuetext = (value) => {
   
    return `${value}%`
  }
  const updateStatus=(event,value)=>{
    
    let values={}
    let user=JSON.parse(window.localStorage.getItem('user'))
    values.completion=event.target.value
     values.projectId=projectId
    values.added_by=user.user_id
    values.taskId=value
    values.task=taskId
    
    if(event.target.value && values.taskId){
      axios.post(`${REST_API_END_POINT}project/update-project-sub-task-progress`,{ ...values },{
        headers: {
          'Content-Type': 'application/json',
        },
        // headers: { 'Content-Type': 'multipart/form-data' }
      })
    }
    
  }
  const handleDeleteSubTask = async (id) => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}project/delete-project-sub-task`,
        { id: Number(id), taskId, projectId, status: 0, isTimeAndMaterial: projectData?.isTimeAndMaterial||projectData?.project_category === 12 }
      );

      if (response.data.status === 4) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setRefreshProjectData(!refreshProjectData)
        setRefresh(!refresh);
        setFetchData(true);
      } else if (response.data.status === 5) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }

      handleCancelDelete(id);
    } catch (error) {
      console.error("Error deleting subtask:", error);
    }
  };

  const handleFetchSubTask = (id)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          // enqueueSnackbar(response.data.message, { variant: 'success' });
          setSingleData(response.data.result[0])
          setIsEdit(true)
         
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleFetchSubTaskView = (id,view=true)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){ 
          // enqueueSnackbar(response.data.message, { variant: 'success' });
        
          setSingleData(response.data.result[0])

          setIsEdit(true)
          setView(view)
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleUpdateStatus = async(id,status)=>{
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{

        // Stopwatch logic for status update
        if (status === 2) { // 'In Progress'
          startStopwatch(id);
        } else if (status === 3 || status === 6) { // 'Completed' or 'In Active'
          const currentStopwatch = subtaskStopwatches[id];
          if (currentStopwatch && currentStopwatch.isRunning) {
            stopStopwatch(currentStopwatch.stopwatchData.id, id);
          }
        }

        const  user  = JSON.parse(window.localStorage.getItem('user'))
        axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(id),task:Number(taskId),projectId,status,userId:user.user_id },{
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if(response.data.status === 1){
            setRefresh(!refresh);
            fetchStopwatchData(id); // Refresh stopwatch data after status change
            enqueueSnackbar(response.data.message, { variant: 'success' });
            setRefreshProjectData(!refreshProjectData)
            setFetchData(true)
          }
        }).catch((error) => {
          console.error(error);
          enqueueSnackbar('Failed to update status', { variant: 'error' });
        })
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
      enqueueSnackbar('Error updating status', { variant: 'error' });
    }
  }

  const handleFinalTaskUpdateStatus = async(stockData)=>{
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{    
        setLoadingInstall(true)   
        const  user  = JSON.parse(window.localStorage.getItem('user'))
        
        axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(finalTaskId),task:Number(taskId),projectId,status :finalTaskStatus,userId:user.user_id,projectCategory: projectData?.project_category,request_id :projectData?.request_id,stockData: stockData || null},{
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if(response.data.status === 1){
            setRefresh(!refresh);
            if(response.data.readyForInstallation){
              console.log("dfgidfbgdfgb");
            }else{
              enqueueSnackbar(response.data.message, { variant: 'success' });
              setOpenPopupComplete(false)
            }
            setRefreshProjectData(!refreshProjectData)
            setFetchData(true)
            setLoadingInstall(false)
          }else if(response.data.status === 0){
            setLoadingInstall(false)
          }
        }).catch((error) => {
          console.error(error);
          setLoadingInstall(false)
        })
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleClose =()=>{
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
    setSubTaskId(null)
  }

  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id);
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id];
      return updatedState;
    });   
  };

  const handleSelectAll = () => {
    if(isSelectAll){
      setIsSelectAll(false);
      setCheckedItems([]);
    }else{
      const allIds = data?.map((post) => String(post.ID)) || [];
      setCheckedItems(allIds);
    }
    setIsSelectAll(!isSelectAll);
  }

  const fetchTimeLogData = async () => {
    try{
      const res = await axios.post(`${REST_API_END_POINT}project-task/fetch-clockedIn-staff-task-timelog`,
      {projectId:projectId,taskId:taskId,userId:userId})
      if(res.data.status===1){
        const staffTimeLogData = res.data.result[0]
        let taskIds = staffTimeLogData?.sub_task_id
        taskIds = taskIds?.toString();
        const taskArray = taskIds?.split(",");
        setCheckedItems(taskArray)
        setStaffTimeLog(staffTimeLogData)
        if(staffTimeLogData.end_time === null){
          setIsLoggedIn(true)
        }else{
          setIsLoggedIn(false)
        }
      }else{
        setStaffTimeLog(null)
        setIsLoggedIn(false)
        setCheckedItems([])
      }
    }catch(error){
      console.log('Error fetching : ',error);
    }
  }

  useEffect(()=>{
    fetchTimeLogData()
  },[isLoggedIn])

  const runningStopwatchKey = Object.entries(subtaskStopwatches)
    .filter(([, state]) => state.isRunning)
    .map(([subtaskId]) => subtaskId)
    .sort()
    .join(',');

  // Tick elapsed time only while stopwatches are running (avoid resetting interval on every second)
  useEffect(() => {
    if (!runningStopwatchKey) return;

    const runningIds = runningStopwatchKey.split(',').filter(Boolean);
    const interval = setInterval(() => {
      setSubtaskStopwatches((prev) => {
        const next = { ...prev };
        let changed = false;

        runningIds.forEach((subtaskId) => {
          const state = prev[subtaskId];
          if (state?.isRunning) {
            changed = true;
            next[subtaskId] = {
              ...state,
              elapsedTime: Math.max(0, (state.elapsedTime || 0) + 1),
            };
          }
        });

        return changed ? next : prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [runningStopwatchKey]);
  

  // Fetch all stopwatch data for subtasks when component mounts or 'data' changes
  useEffect(() => {
    if (data && data.length > 0 && user?.user_id) {
      data.forEach(subtask => {
        fetchStopwatchData(subtask.ID);
      });
    }
  }, [data, user?.user_id]);

  useEffect(() => {
    if(isLoggedIn){
      const intervalId = setInterval(() => {
          setOpenPopup(true);
      }, popUpTime * 60 * 1000);

      return () => {
          clearInterval(intervalId);
      };
    }
}, [isLoggedIn]);

const updateClockInInput = (staffId, data) => {
  setClockInInputs((prev) => {
    const exists = prev.find((item) => item.staff_id === staffId);
    if (exists) {
      return prev.map((item) =>
        item.staff_id === staffId ? { ...item, ...data } : item
      );
    } else {
      return [...prev, { staff_id: staffId, ...data }];
    }
  });
};

const getClockInPayload = () => {
  const now = moment().unix();
  // Get task and subtask names once
  const subtaskData = data?.find(item => item.ID === subTaskId);
  const subtaskName = subtaskData?.name || 'N/A';
  const taskName = taskData?.task_name || taskData?.name || 'N/A';
  
  return clockInInputs
    .filter((entry) => {
      const hasHour = entry.hour > 0;
      return hasHour;
    })
    .map((entry) => {
      // Find staff member to get name
      const staffMember = subTaskMembers.find(member => 
        member.staff_id === entry.staff_id || 
        member.id === entry.staff_id || 
        member.userId === entry.userId
      );
      const staffName = staffMember?.name || staffMember?.staff_name || 'N/A';
      
      return {
        ...entry,
        subtask_id: subTaskId,
        start_time: now - Math.round(entry.hour * 3600),
        end_time: now,
        staff_name: staffName,
        task_name: taskName,
        subtask_name: subtaskName,
      };
    });
};

const handleClockInOut = async() => {
  setLoading2(true)
  const now = moment().unix();
  const memberClockins = getClockInPayload();

  if (memberClockins.length === 0) {
    enqueueSnackbar("Please enter time and select service for at least one member", { variant: 'error' });
    return;
  }

  const payload = {
    projectId,
    taskId,
    userId,
    isDriver: false,
    memberClockins,
    checkedItems: [String(subTaskId)],
    now,
    request_id: requestDetails?.id
  };

  console.log('🧾 Final Payload (not submitted):', payload);
  try {
    const res = await axios.post(
      `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
      payload
      
    );
    console.log('✅ API Response:', res.data);
    if (res.data.status === 1) {
      enqueueSnackbar('Time log added successfully ', { variant: 'success' });
      setClockInInputs([]);      
      setElapsedTime(0);    
      setIsLoggedIn(false);  
      setFetchData(true);
    } else {
      console.log('⚠️ failed to add Time log', res.data);
      enqueueSnackbar("Clock-in failed", { variant: 'error' });
    }
    setOpenService(false)
    if(fromStatus){
      handleUpdateStatus(subTaskId,3);
    }
    handleClose();
    setLoading2(false)
    setLoadingInstall(false)
  } catch (error) {
    console.error('❌ API Error:', error);
    enqueueSnackbar("Clock-in failed", { variant: 'error' });
    handleClose(); 
    setLoading2(false)
    setLoadingInstall(false)
  }
};


const handleClosePopup = (continueWorking) => {
  setOpenPopup(false);
  if (!continueWorking) {
    handleClockInOut();
  }
};

useEffect(() => {
  if(staffTimeLog){
    const interval = setInterval(() => {
      const now = Math.round(moment().valueOf() / 1000);
      const difference = now - staffTimeLog?.start_time;

      setElapsedTime(difference);
    }, 1000);

    return () => clearInterval(interval);
  }
}, [staffTimeLog]);

  const secondsToHHMMSS = (totalSeconds) => {
    const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  const hhmmssToSeconds = (hhmmss) => {
    const parts = hhmmss.split(':').map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) { // Handle HH:MM format if needed
      return parts[0] * 3600 + parts[1] * 60;
    }
    return 0; // Default to 0 if format is incorrect
  };

  const handleEditStopwatch = (stopwatchId, elapsedTime) => {
    setEditingStopwatchId(stopwatchId);
    setEditedTime(secondsToHHMMSS(elapsedTime));
  };

  const handleSaveEditedTime = async (stopwatchId, subtaskId) => {
    try {
      const newElapsedTime = hhmmssToSeconds(editedTime);
      if (isNaN(newElapsedTime)) {
        enqueueSnackbar("Invalid time format. Please use HH:MM:SS", { variant: 'error' });
        return;
      }

      const res = await axios.post(`${REST_API_END_POINT}stopwatch/update`, {
        stopwatchId: stopwatchId,
        userId: user.user_id,
        updateData: { total_time: newElapsedTime }, // Assuming backend expects total_time in seconds
      });

      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch entry updated successfully", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Refresh UI
      } else {
        enqueueSnackbar("Failed to update stopwatch entry", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error saving edited time:", error);
      enqueueSnackbar("Error saving edited time", { variant: 'error' });
    } finally {
      setEditingStopwatchId(null);
      setEditedTime("");
    }
  };

  const fetchAllSkills = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {userId:user.user_id, userType: user.user_type})
      let data = response.data.results.services;
      setSkillsService(data)     
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    fetchAllSkills()
  },[isEdit])

  return (
    <Grid  spacing={3}>
      <Grid item xs={12}>
        {(user.user_type !== 3 && projectData?.status != 3 && projectData?.hold != 1 && projectData?.is_rejected != 1 && canManageEstimateTaskSubtasks) &&
        <Box width={'100%'} display={'flex'} justifyContent={ (currentTab == "Pre-Production") ? 'space-between' : 'flex-end'} mb={2}>
          <Button 
            onClick={() => {
              if (!canManageEstimateTaskSubtasks) {
                enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                return
              }
              setAdd(true)
            }} 
            variant="outlined"
            startIcon={<Icon icon={plusFill} />}
          >
            Add Subtask
          </Button>
        </Box>}
        {data?.length ? data.map((post, index) => {
          // Get stopwatch state for the current subtask
          const currentStopwatchState = subtaskStopwatches[post.ID] || { stopwatchData: null, isRunning: false, elapsedTime: 0 };
          const { stopwatchData, isRunning, elapsedTime } = currentStopwatchState;
          return(
          <Card key={index}
            sx={{
              minWidth: 275,
              mb: 2,
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
              },
              backgroundColor: checkedItems.includes(String(post.ID)) ? theme.palette.divider : null,
            }}
          >
            {/* <Box className={classes.checkboxContainer}>
              <Checkbox sx={{cursor:'pointer'}}
                checked={checkedItems?.includes(String(post?.ID)) ? true : false}
                onChange={() => {isLoggedIn ? null : handleCheckboxChange(String(post.ID))}}
                color="primary"
              />
            </Box> */}
            
            <Box sx={{ px: 2, py: 1, textAlign: 'center', justifyContent: 'center' }}>
            { (user.user_type !== 3 && projectData?.status != 3 && projectData?.hold != 1)&&
              <Stack
                direction={'row'}
                justifyContent={"end"}
                alignItems={'center'}
              >
              {isSelectAll ? null :
               (canManageEstimateTaskSubtasks ? <UserMoreMenu
               onEdit={()=>{
                if (!canManageEstimateTaskSubtasks) {
                  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                  return;
                }
                if(isLoggedIn){
                  enqueueSnackbar('Please clockout to make changes', { variant: 'error' });
                }else{
                  handleFetchSubTask(post.ID)
                }
              }}
               onDelete={()=>{
                if (!canManageEstimateTaskSubtasks) {
                  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                  return;
                }
                if(isLoggedIn){
                  enqueueSnackbar('Please clockout to delete the subtask', { variant: 'error' });
                }else{
                  handleDeleteClick(post.ID)
                }}}
               /> : null)}
              </Stack>}
            </Box>
            <Box sx={{ px: 2,pb: 3, justifyContent: 'space-between' }}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Typography variant="h6" align="center" sx={{cursor:'pointer'}}
                  onClick={()=>handleFetchSubTaskView(post.ID)}>
                  {post.name}
                </Typography>
                {
                  projectData?.project_category !== 12 ?
                <Typography variant="body" align="center">
                  {post?.total_hours ? 'Total Hours : '+post?.total_hours : 'Total Hours : 00:00:00'}
                </Typography> :''
                }
                
               {(projectData?.hold != 1) && <TextField
                    select
                    disabled={((!hasJobPermission && projectData?.status === 1) || projectData?.status == 3 || projectData?.is_rejected == 1) ? true : false}
                    // disabled={(checkedItems?.includes(String(post?.ID)) || isSelectAll || post.status==3) ? true : false}
                    size="small"
                    value={option.find(opt=>opt.id===post.status)?.value || ''}
                    sx={{
                      minWidth: { lg: '50%', md: '40%', sm: '30%' ,color:"#fff"},
                      // height: '30px !important',
                      background: colors[post.status],
                      // color:'blue',
                      borderRadius: 1,
                      border: 'none',
                      '&:hover': {
                        // transform: 'scale(1.02)',
                        border: 'none',
                      },
                    }}
                  >
                    {option.map((optio) => (
                      <MenuItem
                        disabled={(user.user_type == 3 || projectData?.status == 3 || projectData?.hold == 1)? true : false}
                        onClick={() => {
                          if (!hasJobPermission) {
                            enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                            return
                          }
                          if (optio.id === 3) {
                            if(requestDetails?.is_create_estimate != 1){
                              enqueueSnackbar('Please create the estimate before completing', { variant: 'warning'})
                              return;
                            }else{
                              const members = post?.teamMembers
                              handleClockinTime(members,post.ID,true)
                            }
                          }
                          else{
                            if ((Number(post.status) === 2 || Number(post.status) === 3) && optio.id === 1 && requestDetails?.is_create_estimate == 1) {
                              enqueueSnackbar("Job started, can't switch back to New", { variant: 'warning' })
                              return
                            }
                            handleUpdateStatus(post.ID,optio.id)
                          }
                        }}
                        key={optio.value}
                        value={optio.value}
                      >
                        {optio.value}
                      </MenuItem>
                    ))}
                </TextField>}
              </Stack>
            </Box>
            <Box sx={{ display: 'flex',justifyContent:'space-between', alignItems: 'center', p: 2, }}>
             <Stack>    
              <Typography variant="subtitle2">
                   Job Members
                    </Typography>             
                    <AvatarGroup max={4}>
                     {post.teamMembers?.map((row)=>( 
                        <Tooltip key={row.id} title={row.name}>             
                      <Avatar src={row.profile_pic} alt={row.name} />
                      </Tooltip>                   
                     ))}
                    </AvatarGroup>
                  </Stack>
                   {/* Stopwatch UI */}
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body1">Stopwatch:</Typography>
                    {editingStopwatchId === stopwatchData?.id ? (
                      <TextField
                        value={editedTime}
                        onChange={(e) => setEditedTime(e.target.value)}
                        size="small"
                        variant="outlined"
                        sx={{ width: 120, '& input': { textAlign: 'center' } }}
                      />
                    ) : (
                      <Typography
                        variant="h6"
                      //  onDoubleClick={() => elapsedTime > 0 && handleEditStopwatch(stopwatchData?.id, elapsedTime)}
                        sx={{ cursor: elapsedTime > 0 ? 'pointer' : 'default' }}
                      >
                        {secondsToHHMMSS(elapsedTime)}
                      </Typography>
                    )}
                    {!isRunning && (
                      editingStopwatchId === stopwatchData?.id ? (
                        <Button
                          variant="contained"
                          color="success"
                          size="medium"
                          onClick={() => handleSaveEditedTime(stopwatchData.id, post.ID)}
                          sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                        >
                          <Check fontSize="small" />
                        </Button>
                      ) : (
                      null
                      //  <Button
                      //    variant="outlined"
                      //    size="medium"
                      //    onClick={() => handleEditStopwatch(stopwatchData?.id, elapsedTime)}
                      //    disabled={elapsedTime === 0}
                      //    sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                      //  >
                      //    <Edit fontSize="small" />
                      //  </Button>
                      )
                    )}
                    {hasJobPermission ? (
                      isRunning ? (
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => stopStopwatch(stopwatchData.id, post.ID)}
                          size="medium"
                          sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                        >
                          Stop
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => startStopwatch(post.ID)}
                          size="medium"
                          sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                        >
                          Start
                        </Button>
                      )
                    ) : null} 
                    
                    {hasJobPermission && stopwatchData && (stopwatchData.end_time !== null || isRunning) && (
                      <Button
                        variant="outlined"
                        color="warning"
                        onClick={() => clearStopwatch(post.ID)}
                        size="medium"
                        sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                      >
                        <Replay fontSize="small" sx={{ animation: 'resetAnimation 1s infinite' }} />
                      </Button>
                    )}
                  </Stack>
                  {/* End Stopwatch UI */}
                  {hasJobPermission && post?.teamMembers.length > 0 ? (
                    <Button variant='outlined' onClick={()=>handleClockinTime(post?.teamMembers,post.ID)}>Work Time</Button>
                  ) : ''}
            </Box>
            <ConfirmationPopup open={deleteStates[post.ID]} handleClick={()=>handleDeleteSubTask(post.ID)} message={'Want to Delete This SubTask'} handleClose={()=>handleCancelDelete(post.ID)}/>
          </Card>
          )
        }) :
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          No subtasks found 
        </Box>}
      </Grid>
      <ConfirmationPopup open={confirmAdditionalJObCost} handleClick={()=>handleConfirmAdditionalJobCost()} message={confirmMessage} handleClose={()=>{setConfirmAdditionalJObCost(false);setConfirmMessage('');setSearchMaterial('')}}/>
      <WarningMaterialPopup
        open={warningMaterialPopup}
        onClose={handleWarningClose}
        onConfirm={handleWarningConfirm}
        materialName={warningMaterialData?.name || 'Material'}
        qty={qty || 1}
      />
      <AddTask title={isEdit ? view?'View SubTask':'Edit SubTask' : 'Add SubTask'} data={singleData} setData={setSingleData} setFetchData={setFetchData} projectMembers={projectMembers} taskId={taskId} add={add || isEdit} setAdd={isEdit ? setIsEdit : setAdd} projectId={projectId} view={view} setView={setView} skillsandServices={skillsandServices} details={details} isTimeAndMaterial={projectData?.project_category === 12} />
      <ProjectStatusPopup open={openPopup} onClose={handleClosePopup} staffTimeLogData={staffTimeLog} handleClockInOut={handleClockInOut} autoClockoutTime={autoClockoutTime} />
      <Modal
      open={viewMaterial ? true : false}
      handleClose={() => {
        setViewMaterialData([]);
        setViewMaterial(false);
      }}
      modalTitle={'Materials added'}
    >
      {loadingMaterials ?
      (
        <CircularProgress color="primary" variant="indeterminate" />
      ) : (
        viewMaterialData?.length > 0 ?
        <TableContainer component={Paper}>
          <Table>
              <TableHead>
                  <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Barcode</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Unit Cost</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Total</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {viewMaterialData?.map((material, index) => (
                      <TableRow key={material.id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{material.barcode}</TableCell>
                          <TableCell>{material.productName}</TableCell>
                          <TableCell>{material.unit_price}</TableCell>
                          <TableCell>{material.quantity}</TableCell>
                        <TableCell>{parseFloat(material.unit_price * material.quantity).toFixed(2)}</TableCell>
                          {/* <TableCell>{material.total}</TableCell> */}
                      </TableRow>
                  ))}
              </TableBody>
          </Table>
        </TableContainer>
        :
        <Typography>No materials added</Typography>
      )}
    </Modal>
      {finalTaskStatus === 3 && ((projectData?.project_category === 15 && projectData?.is_split_order !== 1) || (projectData?.project_category === 15 && projectData?.is_split_order !== 1)) ? (
        <Dialog open={openPopupComplete} onClose={() => setOpenPopupComplete(false)}>
          <DialogContent>
            <Stack direction="column" spacing={2}>
              <Typography variant='h6'>Are you sure you want to complete this Job?</Typography>
              <Alert severity='warning'>If this job is completed, stock will be added to the selected Catalog. Once completed, this job & sales order will move directly to the Completed tab.</Alert>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' color='inherit' onClick={() => setOpenPopupComplete(false)}>No</Button>
            <Button
              variant="contained"
              sx={{ boxShadow: 'none' }}
              onClick={() => {
                setOpenPopupComplete(false);
                handleFinalTaskUpdateStatus();
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <ConfirmationPopup
          isComplete={true}
          loading2={loadingInstall}
          setCompleteStatus={setCompleteStatus}
          noServiceNoTask={details?.noServiceNoTask}
          projectCategory={projectData?.project_category}
          projectId={projectId}
          projectTasks={finalTaskId ? [taskData] : []}
          open={openPopupComplete}
          handleClick={(stockData) => {
            handleFinalTaskUpdateStatus(stockData);
          }}
          hideCancel={true}
        />
      )}
          <Dialog
            aria-describedby="alert-dialog-slide-description"
            TransitionComponent={Transition}
            transitionDuration={500}
            open={openService}
            PaperProps={{
              sx: {
                width: { xs: '90%', sm: '60%' , md:'70%' },
                p: 2,
                borderRadius: 2
              }
            }}
          >
            <DialogContent
              sx={{
                mt: 1,
                px: 2,
                overflowY: 'auto',
                overflowX: 'auto',
                scrollbarWidth: 'thin', 
                '&::-webkit-scrollbar': {
                  width: '0.75rem',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(110, 108, 108, 0.32)',
                  borderRadius: '4px',
                },
                maxHeight: 500,
              }}
            >
              <Table size="small" sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                      <strong>Member</strong>
                    </TableCell>
                    {/* <TableCell align="center" sx={{ width: '40%', py: 1 }}>
                      <strong>Service</strong>
                    </TableCell> */}
                    <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          Time
                        </Typography>
                        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                          (HH:MM)
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                  (isAdminUser (userType) || userType === 8
                    ? subTaskMembers
                    : subTaskMembers.filter((item) => item.userId === userId)
                    ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No job members available
                      </TableCell>
                    </TableRow>
                    ) : 
                  (isAdminUser (userType) || userType === 8
                      ? subTaskMembers
                      : subTaskMembers.filter((item) => item.userId === userId)
                    ).map((item) => (
                    <TableRow key={item.id} sx={{mt:2, height: 44 }}>
                      <TableCell align="center">{item.name}</TableCell>
                      <TableCell>
                          <Stack direction="row" spacing={1} justifyContent="center">
                            <TextField
                              name="hours"  
                              label="Hours"
                              placeholder="01"
                              size="small"
                              sx={{ width: 80 }}
                              inputProps={{ min: 0 }}
                              // defaultValue={0}
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const h = parseInt(e.target.value || '0', 10);
                                const m = parseInt(
                                  e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                taskData?.is_manually_added === 1 ? null :
                                  taskData?.service_id == null
                                    ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                    : filteredClockInServices.find((opt) => opt.id === taskData.customer_order_product_id)?.id || null;

                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  hourly_rate: item.hourly_rate,
                                  userId: item.userId,
                                  service_id: selectedServiceId
                                });
                              }}
                            />

                            <TextField
                              label="Minutes"
                              name="minutes"
                              placeholder="30"
                              size="small"
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              sx={{ width: 80 }}
                              inputProps={{ min: 0, max: 60 }}
                              // defaultValue={0}
                              onInput={(e) => {
                                const value = parseInt(e.target.value || '0', 10);
                                if (value > 60) {
                                  e.target.value = 60;
                                } else if (value < 0) {
                                  e.target.value = 0;
                                }
                              }}
                              onChange={(e) => {
                                let m = parseInt(e.target.value || '0', 10);
                                let h = parseInt(
                                  e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                  taskData?.service_id == null
                                    ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                    : filteredClockInServices.find((opt) => opt.id === taskData.customer_order_product_id)?.id || null;

                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  hourly_rate: item.hourly_rate,
                                  userId: item.userId,
                                  service_id: selectedServiceId
                                });
                              }}
                            />
                          </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>

              </Table>
            </DialogContent>

            <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
              <Button
                onClick={() => {
                  handleClose();
                  enqueueSnackbar('Operation was cancelled', { variant: 'error' });
                }}
                sx={{
                  background: '#BB2525',
                  color: '#fff',
                  '&:hover': {
                    background: '#FF8F8F',
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  handleClockInOut()
                }
                }
                disabled={isClockInDisabled}
              >
                {loading2 ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Clock In'
                )}
              </Button>
            </Stack>
          </Dialog>
          {/* : ''
      } */}

    </Grid>
  )
}
